export default __webpack_public_path__ + "static/11aa-34212d073ebb147e69f1cf2bba5c17dd.png";